import { useSession } from "@/lib/session.tsx";
import { useBrand } from "@/lib/brand.tsx";
import { cn } from "@/lib/utils.ts";

export interface BrandLogoProps {
  size?: "sm" | "default" | "lg";
  className?: string;
  wordmark?: boolean;
}

const heights = { sm: "h-6", default: "h-8", lg: "h-10" } as const;
const text = { sm: "text-sm", default: "text-base", lg: "text-xl" } as const;

export function BrandLogo({ size = "default", className, wordmark = true }: BrandLogoProps) {
  const { operator } = useSession();
  const brand = useBrand(operator);
  if (brand.logo) {
    return <img src={brand.logo} alt={brand.name} className={cn(heights[size], "w-auto max-w-[160px] object-contain", className)} />;
  }
  const platform = !operator || operator.id === 0 || /^ftp ?edi$/i.test(brand.name.trim());
  if (platform) {
    return (
      <span className={cn("inline-flex items-center gap-2", className)} aria-label="FTP EDI">
        <img src="/brand/mark.svg" alt="" className={cn(heights[size], "w-auto shrink-0")} />
        {wordmark && <span className={cn("truncate font-bold tracking-tight", text[size])}>FTP <span className="text-primary">EDI</span></span>}
      </span>
    );
  }
  const initial = brand.name.trim().charAt(0).toUpperCase() || "E";
  return (
    <span className={cn("inline-flex items-center gap-2", className)} aria-label={brand.name}>
      <span className={cn("grid shrink-0 place-items-center rounded-md bg-primary font-semibold text-primary-foreground", size === "sm" ? "size-6 text-xs" : size === "lg" ? "size-10 text-lg" : "size-8 text-sm")} aria-hidden="true">
        {initial}
      </span>
      {wordmark && <span className={cn("truncate font-semibold tracking-tight", text[size])}>{brand.name}</span>}
    </span>
  );
}

export default BrandLogo;
